<template>
  <div class="wrapper">
    <div class="columns is-gapless wrapper-page">
      <div id="pano" class="column is-10">
        <noscript>
          <table style="width:100%;height:100%;">
            <tr style="vertical-align:middle;">
              <td>
                <div style="text-align:center;">ERROR:<br/><br/>Javascript not activated<br/><br/></div>
              </td>
            </tr>
          </table>
        </noscript>
      </div>
      <div id="editor" class="column is-2">
        <EditorSide ref="editor" />
      </div>
    </div>
  </div>
</template>
<script>
import EditorSide from './EditorSide'
export default {
  components: {
    EditorSide
  },
  data() {
    return {

    }
  },
  mounted() {
    embedpano({
      // 该文件仅用于Flashplayer，而仅使用HTML5时，则不需要此文件。
      swf: "/static/tour.swf",
      xml: "/static/tour2.xml",
      target: "pano",
      html5: "auto",
      mobilescale: 1.0,
      // 布尔设置。设置为true时，来自html url的所有查询参数将作为变量传递给查看器。
      passQueryParameters: true,
      onready: this.krpano_onready_callback
    });
  },
  methods: {
    krpano_onready_callback(krpano) {
      console.log('ready', krpano)
      this.$refs.editor.onready()
    }
  }
}
</script>
<style scoped>
  .wrapper {
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// Editor.vue?204bc078